import styled from 'styled-components';

import colors from '~/styles/colors';

interface StyledButtonProps {
  variant: 'solid' | 'outline' | 'ghost';
}

export const StyledButton = styled.button<StyledButtonProps>`
  font-weight: ${(props) => (props.variant === 'ghost' ? 'normal' : 'bold')};
  color: ${(props) => (props.variant !== 'solid' ? colors.primary : '#ffffff')};
  color: ${(props) => props.variant === 'ghost' && '#4d4d4d'};
  background-color: ${(props) =>
    props.variant !== 'solid' ? 'transparent' : colors.primary};
  height: 39px;
  padding: 0 23.5px;
  border-radius: 5px;
  border-color: ${colors.primary};
  border: ${(props) =>
    props.variant !== 'solid' ? `1px solid ${colors.primary}` : 'none'};
  border: ${(props) => props.variant === 'ghost' && 'none'};
  outline: none;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${(props) =>
      props.variant !== 'solid' ? colors.lightpink : colors.darkprimary};
    border-color: ${(props) =>
      props.variant !== 'solid' ? 'none' : colors.darkprimary};
  }

  &:active {
    background-color: ${colors.darkprimary};
    border-color: ${colors.darkprimary};
  }

  &.primary {
    color: #fff;
    background-color: ${colors.primary};

    &:hover {
      background-color: ${colors.darkprimary};
      border-color: ${colors.darkprimary};
    }

    &:active {
      background-color: ${colors.darkprimary};
      border-color: ${colors.darkprimary};
    }
  }

  &.secondary {
    color: #4d4d4d;
    background-color: transparent;

    &:hover {
      color: ${colors.primary};
      background-color: transparent;
      border-color: transparent;
    }

    &:active {
      color: ${colors.primary};
      background-color: transparent;
      border-color: transparent;
    }
  }

  &.block {
    width: 100%;
  }

  &:disabled {
    border: 1px solid ${colors.primary} !important;
    opacity: 0.3;
  }
`;
